<template>
    <div class="sidebar">
        <!--loginInfo-->
        <!--<div class="doc-info el-menu flex column aic jcc pt15 pb15" :style="{backgroundColor:leftBg}">
            <img :src="docInfo.docAvatar" class="ava" alt="">
            <template v-if="collapse===false">
                <p class="color_fff fs16 mt10">
                    <b>{{docInfo.docName}}</b>
                </p>
                <p class="fs14 mt10 flex color_fff">
                    <span>{{docInfo.deptName}}</span>
                    <span class="ml10">{{docInfo.docTitle}}</span>
                </p>
                <p class="mt10 color_fff fs14">
                    {{docInfo.hosName}}
                </p>
            </template>
        </div>-->

        <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" :background-color="leftBg"
                 text-color="#bfcbd9" unique-opened router>
            <template v-for="item in menuList">
                <template v-if="item.subMenu">
                    <el-submenu :index="item.showIndex" :key="item.index">
                        <template slot="title">
                            <i :class="item.iconName" class="iconfont mr5"></i><span slot="title">{{ item.menuName }}</span>
                        </template>
                        <el-menu-item v-for="(subItem,i) in item.subMenu" :key="i" :index="subItem.menuUrl">
                            {{ subItem.menuName }}
                        </el-menu-item>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.menuUrl" :key="item.index">
                        <i :class="item.iconName" class="iconfont mr5"></i><span slot="title">{{ item.menuName }}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
  import {LEFT_BG} from "../../lib/config";
  import {isEmpty} from "../../lib/utils";

  export default {
    data() {
      return {
        leftBg: LEFT_BG,
        collapse: false,
        items: []
      }
    },
    computed: {
      onRoutes() {
        return this.$route.path;
      }
    },
    created() {
      // 通过 Event Bus 进行组件间通信，来折叠侧边栏
      bus.$on('collapse', msg => {
        this.collapse = msg;
      });
    },
    methods: {}
  }
</script>

<style scoped lang="scss">
    .sidebar {
        display: block;
        position: absolute;
        left: 0;
        overflow-y: auto;
        top: 70px;
        bottom: 0;
    }

    .sidebar-el-menu:not(.el-menu--collapse) {
        width: 190px;
    }

    .sidebar > ul {
        height: 100%;
    }

    .el-submenu .el-menu-item {
        min-width: auto;
    }

</style>
